var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"aq"},[_c('div',{staticClass:"hander"},[_c('van-icon',{staticClass:"nav_goback",attrs:{"name":"arrow-left"},on:{"click":_vm.goBack}})],1),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }